<template>
  <div>
    <section>
      <div class="warp">
        <div class="left animate__animated animate__fadeInLeft">
          <h3>{{ info.top_title }}</h3>
          <p v-html="info.top_des"></p>
        </div>
        <div class="right animate__animated animate__fadeInRight">
          <video v-if="info?.top_thumb?.endsWith('mp4')" :src="$baseURL + info?.top_thumb" autoplay muted></video>
          <img v-else :src="$baseURL + info?.top_thumb" :alt="info.top_title" />
        </div>
      </div>
    </section>
    <section>
      <div class="warp">
        <div class="left">
          <h3>{{ info.foot_title }}</h3>
          <p v-html="info.foot_des"></p>
        </div>
        <div class="right">
          <video v-if="info?.foot_thumb?.endsWith('mp4')" :src="$baseURL + info?.foot_thumb" autoplay muted></video>
          <img v-else :src="$baseURL + info?.foot_thumb" :alt="info.foot_title" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      info: {},
    };
  },
  methods: {
    async aboutIndex() {
      let res = await service.aboutIndex();
      if (res.code == 1) {
        this.info = res.data.aboutinfo;
      }
    },
  },
  created() {
    this.aboutIndex();
  },
};
</script>

<style lang="less" scoped>
section {
  .warp {
    display: flex;
    background-repeat: no-repeat;
    background-size: auto 100%;

    .left {
      flex: 1;

      h3 {
        font-size: 30px;
      }

      p {
        color: #999999;
        line-height: 2;
        margin-top: 30px;
        font-size: 16px;
      }
    }

    .right {
      width: 58%;

      video,
      img {
        width: 100%;
      }
    }
  }

  &:nth-child(2n + 1) {
    .warp {
      padding-left: var(--containerLeft);
      background-image: url(../../assets/image/about_js_bg_2.svg);

      .left {
        margin-right: 50px;
      }
    }
  }

  &:nth-child(2n) {
    .warp {
      align-items: center;
      flex-direction: row-reverse;
      padding-right: var(--containerLeft);
      background-image: url(../../assets/image/about_js_bg_1.svg);
      background-position-x: right;

      .left {
        margin-left: 50px;
      }
    }
  }
}

@media (max-width: 700px) {
  section {
    .warp {
      display: block;

      .left,
      .right {
        width: 100%;
        flex: auto;
      }
    }

    &:nth-child(2n),
    &:nth-child(2n + 1) {
      .warp {
        padding: 0 4vw;

        .left {
          margin-right: 0;
          margin-left: 0;
        }
      }
    }
  }
}
</style>